export default "__VITE_ASSET__BQvwZkqe__"